import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Utils } from './utils/utils';
import { Constants } from '../model/constants';

@Injectable({
  providedIn: 'root'
})
export class DomainService {

    constructor(private http: HttpClient) { }

    loadProvince(): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'domain/province';
        return this.http.get(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

}
